module.exports = __webpack_public_path__ + "img/海螺型材.897b4604.png";